import * as Sentry from '@sentry/react';

/**
 * Initializes Sentry/GlitchTip error tracking.
 * Only active when REACT_APP_SENTRY_DSN is set (i.e. staging/production).
 * Safe to call in local development — a missing DSN is a no-op.
 */
export function initSentry(): void {
  const dsn = process.env.REACT_APP_SENTRY_DSN;
  if (!dsn) return;

  Sentry.init({
    dsn,
    environment: process.env.NODE_ENV,
    tracesSampleRate: 1.0,
    integrations: [Sentry.browserTracingIntegration()],
  });
}

